(function() {
  'use strict';

  var allBrands = [];
  var filteredBrands = [];
  var activeLetter = null;
  var searchQuery = '';
  var renderedCount = 0;
  var chunkObserver = null;
  var yetkiliActive = false;
  var yetkiliSet = {};

  /* --- DOM refs --- */
  var brandsPage = document.querySelector('[data-brands-page]');
  var grid = document.querySelector('[data-brands-grid]');
  var loading = document.querySelector('[data-brands-loading]');
  var empty = document.querySelector('[data-brands-empty]');
  var countEl = document.querySelector('[data-brands-count]');
  var searchInput = document.querySelector('[data-brands-search]');
  var searchBtn = document.querySelector('[data-brands-search-btn]');
  var alphaGrid = document.querySelector('[data-brands-alpha-grid]');
  var yetkiliBtn = document.querySelector('[data-brands-yetkili]');
  var footerEl = document.querySelector('[data-brands-infinite-footer]');
  var loaderEl = document.querySelector('[data-brands-loader]');
  var statusEl = document.querySelector('[data-brands-status]');
  var sentinelEl = document.querySelector('[data-brands-sentinel]');

  if (!grid) return;

  var CHUNK_SIZE = parseInt(brandsPage && brandsPage.getAttribute('data-chunk-size'), 10) || 24;

  /* --- Parse app metafield JSON [{n,s,u,i}] --- */
  function loadBrandsData() {
    var el = document.getElementById('mytheme-brands-data');
    if (!el) return [];
    try {
      var raw = JSON.parse(el.textContent.trim());
      if (typeof raw === 'string') raw = JSON.parse(raw);
      if (!Array.isArray(raw)) return [];

      /* Deduplicate by slug, ensure URL fallback */
      var brands = [];
      var seen = {};
      for (var i = 0; i < raw.length; i++) {
        var b = raw[i];
        if (!b.s || seen[b.s]) continue;
        seen[b.s] = true;
        if (!b.u) b.u = '/collections/' + b.s;
        brands.push(b);
      }
      return brands;
    } catch (e) {
      console.error('Brands JSON parse error:', e);
      return [];
    }
  }

  /* --- Normalize Turkish characters for search --- */
  function normalize(str) {
    return str
      .replace(/İ/g, 'i')
      .replace(/I/g, 'i')
      .replace(/Ğ/g, 'g')
      .replace(/Ü/g, 'u')
      .replace(/Ş/g, 's')
      .replace(/Ö/g, 'o')
      .replace(/Ç/g, 'c')
      .toLowerCase()
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c');
  }

  /* --- Parse yetkili-satıcı vendor names (from collection.all_vendors) --- */
  function loadYetkiliVendors() {
    var el = document.getElementById('mytheme-yetkili-vendors');
    if (!el) return {};
    try {
      var raw = JSON.parse(el.textContent.trim());
      if (typeof raw === 'string') raw = JSON.parse(raw);
      if (!Array.isArray(raw)) return {};
      var set = {};
      for (var i = 0; i < raw.length; i++) {
        if (raw[i]) set[normalize(String(raw[i]))] = true;
      }
      return set;
    } catch (e) {
      console.error('Yetkili vendors JSON parse error:', e);
      return {};
    }
  }

  /* --- Get first letter (Turkish-aware) --- */
  function getFirstLetter(title) {
    if (!title) return '';
    var first = title.charAt(0).toUpperCase();
    if (first === 'İ') return 'I';
    return first;
  }

  /* --- Filter brands by letter and search query --- */
  function applyFilters() {
    filteredBrands = allBrands.filter(function(brand) {
      var matchLetter = true;
      var matchSearch = true;
      var matchYetkili = true;

      if (activeLetter) {
        matchLetter = getFirstLetter(brand.n) === activeLetter;
      }

      if (searchQuery) {
        matchSearch = normalize(brand.n).indexOf(normalize(searchQuery)) !== -1;
      }

      if (yetkiliActive) {
        matchYetkili = brand._yetkili === true;
      }

      return matchLetter && matchSearch && matchYetkili;
    });

    resetAndRender();
  }

  /* --- Update alpha button states --- */
  function updateAlphaButtons() {
    if (!alphaGrid) return;

    var availableLetters = {};
    allBrands.forEach(function(brand) {
      availableLetters[getFirstLetter(brand.n)] = true;
    });

    var buttons = alphaGrid.querySelectorAll('[data-brands-letter]');
    buttons.forEach(function(btn) {
      var letter = btn.getAttribute('data-brands-letter');
      if (availableLetters[letter]) {
        btn.disabled = false;
        btn.classList.remove('brands-page__alpha-btn--disabled');
      } else {
        btn.disabled = true;
        btn.classList.add('brands-page__alpha-btn--disabled');
      }
    });
  }

  /* --- Build a single brand card --- */
  function buildCard(brand) {
    var card = document.createElement('a');
    card.href = brand.u;
    card.className = 'brand-card';

    var imageDiv = document.createElement('div');
    imageDiv.className = 'brand-card__image';

    if (brand.i) {
      var img = document.createElement('img');
      img.src = brand.i;
      img.alt = brand.n;
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      imageDiv.appendChild(img);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'brand-card__placeholder brand-card__placeholder--name';
      placeholder.textContent = brand.n;
      imageDiv.appendChild(placeholder);
    }

    var nameDiv = document.createElement('div');
    nameDiv.className = 'brand-card__name';
    nameDiv.textContent = brand.n;

    card.appendChild(imageDiv);
    card.appendChild(nameDiv);
    return card;
  }

  /* --- Append a chunk of brands to the grid --- */
  function appendChunk(startIndex, endIndex) {
    var fragment = document.createDocumentFragment();
    for (var i = startIndex; i < endIndex && i < filteredBrands.length; i++) {
      fragment.appendChild(buildCard(filteredBrands[i]));
    }
    grid.appendChild(fragment);
  }

  /* --- Clear existing brand cards (keep skeletons) --- */
  function clearCards() {
    var existingCards = grid.querySelectorAll('.brand-card:not(.brand-card--skeleton)');
    existingCards.forEach(function(card) { card.remove(); });
  }

  /* --- Update infinite scroll UI (status, sentinel, footer visibility) --- */
  function updateInfiniteState() {
    if (loaderEl) loaderEl.hidden = true;

    var total = filteredBrands.length;
    var done = renderedCount >= total;

    if (total === 0) {
      if (footerEl) footerEl.hidden = true;
      return;
    }

    if (footerEl) footerEl.hidden = false;

    if (statusEl) {
      if (done) {
        statusEl.textContent = 'Tüm markalar yüklendi';
        statusEl.hidden = false;
      } else {
        statusEl.textContent = '';
        statusEl.hidden = true;
      }
    }

    if (sentinelEl) {
      sentinelEl.hidden = done;
    }
  }

  /* --- Full reset: clear grid + render first chunk --- */
  function resetAndRender() {
    clearCards();

    if (countEl) {
      countEl.textContent = filteredBrands.length + ' marka bulundu';
    }

    if (filteredBrands.length === 0) {
      if (empty) empty.hidden = false;
      renderedCount = 0;
      updateInfiniteState();
      return;
    }

    if (empty) empty.hidden = true;

    renderedCount = Math.min(CHUNK_SIZE, filteredBrands.length);
    appendChunk(0, renderedCount);
    updateInfiniteState();
  }

  /* --- Load next chunk (append without clearing) --- */
  function loadNextChunk() {
    if (renderedCount >= filteredBrands.length) return;
    if (loaderEl) loaderEl.hidden = false;
    if (statusEl) statusEl.hidden = true;

    var nextEnd = Math.min(renderedCount + CHUNK_SIZE, filteredBrands.length);
    appendChunk(renderedCount, nextEnd);
    renderedCount = nextEnd;

    updateInfiniteState();
  }

  /* --- Set up IntersectionObserver on sentinel --- */
  function initInfiniteObserver() {
    if (!('IntersectionObserver' in window) || !sentinelEl) return;

    chunkObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && renderedCount < filteredBrands.length) {
        loadNextChunk();
      }
    }, { rootMargin: '400px 0px' });

    chunkObserver.observe(sentinelEl);
  }

  /* --- Event: Letter filter --- */
  if (alphaGrid) {
    alphaGrid.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-brands-letter]');
      if (!btn || btn.disabled) return;

      var letter = btn.getAttribute('data-brands-letter');

      if (activeLetter === letter) {
        activeLetter = null;
        btn.classList.remove('brands-page__alpha-btn--active');
      } else {
        var prev = alphaGrid.querySelector('.brands-page__alpha-btn--active');
        if (prev) prev.classList.remove('brands-page__alpha-btn--active');
        activeLetter = letter;
        btn.classList.add('brands-page__alpha-btn--active');
      }

      applyFilters();
    });
  }

  /* --- Event: Search --- */
  function doSearch() {
    searchQuery = (searchInput ? searchInput.value : '').trim();
    applyFilters();
  }

  if (searchInput) {
    var debounceTimer = null;
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 250);
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(debounceTimer);
        doSearch();
      }
    });
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', doSearch);
  }

  /* --- Event: Yetkili satıcı toggle --- */
  if (yetkiliBtn) {
    yetkiliBtn.addEventListener('click', function() {
      yetkiliActive = !yetkiliActive;
      yetkiliBtn.classList.toggle('brands-page__yetkili-btn--active', yetkiliActive);
      yetkiliBtn.setAttribute('aria-pressed', yetkiliActive ? 'true' : 'false');
      applyFilters();
    });
  }

  /* --- Init --- */
  yetkiliSet = loadYetkiliVendors();
  allBrands = loadBrandsData();

  /* Tag brands present in the yetkili-satıcı vendor set */
  allBrands.forEach(function(brand) {
    brand._yetkili = yetkiliSet[normalize(brand.n)] === true;
  });

  /* Hide the yetkili button if no loaded brand actually matches */
  if (yetkiliBtn && !allBrands.some(function(brand) { return brand._yetkili; })) {
    yetkiliBtn.hidden = true;
  }

  /* Sort alphabetically (Turkish locale) */
  allBrands.sort(function(a, b) {
    return a.n.localeCompare(b.n, 'tr');
  });

  filteredBrands = allBrands.slice();

  /* Hide skeleton, render first chunk, wire up infinite scroll */
  if (loading) loading.hidden = true;
  resetAndRender();
  updateAlphaButtons();
  initInfiniteObserver();
})();
